import { useQuery, UseQueryResult } from 'react-query';
import { getActions, TGetActionsResponse } from '../api/actions';

export function useGetActions(): UseQueryResult<TGetActionsResponse> {
    return useQuery(['getActions'], () => getActions(), {
        retry: false,
        staleTime: Infinity,
        cacheTime: 100,
    });
}
